import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function actionCard(): ComponentStyle {
  return {
    componentName: 'actionCard',
    variants: {}
  };
}
